export function debounce(func, delay, leading) {
  let timerId;

  return (...args) => {
    if (!timerId && leading) {
      func(...args);
    }
    clearTimeout(timerId);

    timerId = setTimeout(() => func(...args), delay);
  };
}

export function throttle(func, delay) {
  let timerId;
  let lastExecutedTime = 0;

  return (...args) => {
    const currentTime = Date.now();

    if (currentTime - lastExecutedTime >= delay) {
      func(...args);
      lastExecutedTime = currentTime;
    } else {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func(...args);
        lastExecutedTime = currentTime;
      }, delay);
    }
  };
}

export function booleanDataset(el, name, value) {
  if (value) {
    el.dataset[name] = '';
  }
  else {
    delete el.dataset[name];
  }
}

export function hasBooleanDataset(el, name) {
  return el.dataset[name] !== undefined;
}

export function dispatchEvent(eventName, detail) {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
}
